import * as testConst from 'app/constants/tests';
import { AppStoreState } from 'app/redux/store';
import { useTranslation } from 'next-i18next';
import { countWords } from 'app/utils/string';
import { toggleClass } from 'app/utils/dom';
import * as testApi from 'app/requests/tests';
import { useSelector } from 'react-redux';
import { Passage } from 'types/test';
import { User } from 'types/auth';
import { useEffect } from 'react';

const IeltWrite = ({ confirmIsReady, passagesOfUser, setPassagesUser }) => {
  const { test, currentPage, process } = useSelector((state: AppStoreState) => state.test);
  const { auth } = useSelector((state: AppStoreState) => state.global);
  const { t } = useTranslation();

  useEffect(() => {
    fetchPassageForUser(auth);
  }, [auth]);

  const fetchPassageForUser = async (user: User) => {
    if (user?.id) {
      let passages = await testApi.getPassageByUserId(test.id, user.id);
      passages = genaratePassagesForUser(passages);
      setPassagesUser(passages);
    }
  }

  const changePassage = (passage: Passage, indexPassage: number) => {
    const dataPassages = JSON.parse(JSON.stringify(passagesOfUser))
    if (!passage.isNew) passage['isEdit'] = true;
    dataPassages[indexPassage] = passage;
    setPassagesUser(dataPassages)
  }

  const genaratePassagesForUser = (passages: Passage[]) => {
    return testConst.IELT_WRITE.map((passage_number) => {
      const passage = passages?.find(passage => passage.passage_number == passage_number);
      if (passage) return passage;

      return {
        isNew: true,
        content: '',
        suggestions: '',
        test_id: test.id,
        user_id: auth.id,
        passage_number
      }
    });
  }

  return (
    <div className="form-ielts-write mb-4">
      {(test?.passages || []).map((passage: Passage, index: number) => {
        const passageOfUser = passagesOfUser?.find((item: Passage) => {
          return item.passage_number == passage.passage_number;
        });

        return (
          <div key={passage.passage_number} className={passage.passage_number != currentPage ? 'd-none' : ''}>
            <div className="card card-body" style={{ width: '100%' }}>
              <span dangerouslySetInnerHTML={{ __html: passage?.content }} />
              <h3 className="text-center text-info">
                {t('tests.ielts_test_write')}
                <p className="text-center text-secondary text-size-md">
                  {t('tests.ielts_test_write_des', { minus: currentPage == 1 ? 20 : 40, currentPage })}
                </p>
              </h3>
              <div onClick={() => confirmIsReady()}>
                <label className="text-info font-weight-bold float-right">
                {t('tests.word_count')}: {countWords(passageOfUser?.content)}
                </label>
                <textarea
                  rows={10}
                  value={passageOfUser?.content || ''}
                  readOnly={['init', 'complete'].includes(process)}
                  className="form-control"
                  onChange={({ target: { value } }) => changePassage({...passageOfUser, content: value}, index)}
                />
              </div>
            </div>
            <div className={`my-3 ${process != 'complete' ? 'd-none' : ''}`}>
              <a className="font-weight-bold text-info mb-4 cursor-pointer" onClick={() => toggleClass(`#collapse_${passage.id}`, 'd-block')}>
                <u className="mb-2">{t('tests.ielts_write_sample')}</u>
                <span className="dropdown-toggle"></span>
              </a>
              <div className="d-none" id={`collapse_${passage.id}`}>
                <div className="card card-body" style={{ width: '100%' }}>
                  <span
                    style={{ whiteSpace: 'pre-line' }}
                    dangerouslySetInnerHTML={{ __html: passage?.suggestions || '' }}
                  />
                </div>
              </div>
            </div>
          </div>
        )
      })
      }
    </div>
  )
}

export default IeltWrite;
